import React from 'react'
import { FooterHeadingLink } from '../../elements/FooterHeadingLink'
import { FooterSection, IProps as IFooterSection } from '../../elements/FooterSection'
import { FooterAutopilotBlogLinks } from '../../elements/FooterAutopilotBlogLinks'
import { IProps, PrimaryLink } from './index'
import { VisuallyHidden } from '../../elements/VisuallyHidden'
import styles from './styles.scss'
import useTranslate from '../../hooks/useTranslate'
import SecondaryLinkRenderer from './SecondaryLinksRenderer'

// Type guards
function isFooterSection(data: PrimaryLink): data is IFooterSection {
  return !!(data as IFooterSection).links
}

export const Footer = ({
  primaryLinks,
  secondaryLinks,
  renderExtraContent,
}: IProps): React.ReactElement => {
  const { translate } = useTranslate()

  return (
    <footer className="footer" id="site-footer">
      <VisuallyHidden>
        <span id="sitemap">{translate('Sitemap')}</span>
      </VisuallyHidden>
      <nav className="content-wrapper" aria-labelledby="sitemap">
        <div>
          <ul className="primary-links">
            {primaryLinks.map((section, index) => {
              return (
                <li key={index} className="primary-links__list-item">
                  {isFooterSection(section) ? (
                    <FooterSection heading={section.heading} links={section.links} />
                  ) : (
                    <FooterHeadingLink text={section.text} url={section.url} />
                  )}
                </li>
              )
            })}
          </ul>
        </div>
        <div className="blog-content">
          <FooterAutopilotBlogLinks />
        </div>
        {renderExtraContent && <span className="extra-content">{renderExtraContent()}</span>}
        <ul className="secondary-links">
          {secondaryLinks &&
            secondaryLinks.map((link, index) => {
              return <SecondaryLinkRenderer secondaryLink={link} key={`secondary-link_${index}`} />
            })}
        </ul>
      </nav>
      <style jsx>{styles}</style>
    </footer>
  )
}
